import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faM, faT, faR, faTimes, faFileAlt, faListAlt, faChartBar, faBoxOpen, faUser, faBook, faCubes, faTags, faBuilding, faBalanceScale, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './Auditusierp_Demo.css';
import menuData from './AuditusierpDemo.json';


// Icon mapping for dropdown items (customize as needed)
const itemIcons = {
    'Account': faUser,
    'Account Group': faBook,
    'Product': faBoxOpen,
    'Product Group': faTags,
    'Product Company': faBuilding,
    'Unit': faCubes,
    'Sales': faChartBar,
    'Sales Group': faListAlt,
    'Purchase': faChartBar,
    'Purchase Group': faListAlt,
    'Trial Balance': faBalanceScale,
    'Profit & Loss A/C': faBalanceScale,
    'Balance Sheet': faBalanceScale,
    'Daybook': faBook,
    'Ledger': faBook,
    'Payment Register': faFileAlt,
    'Receipt Register': faFileAlt,
    'Sale Register': faFileAlt,
    'Purchase Register': faFileAlt,
    'Sales Return': faFileAlt,
    'Purchase Return': faFileAlt,
    'Sale Accounts': faFileAlt,
    'Purchase Accounts': faFileAlt,
    'Stock Summary': faCubes,
};

export default function Menu() {
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
    const [activePanel, setActivePanel] = useState(null);
    const [activeGroups, setActiveGroups] = useState({});
    const [openTabs, setOpenTabs] = useState([]);
    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        if (activePanel) {
            setActiveGroups((prev) => ({
                ...prev,
                [activePanel]: menuData[activePanel].map((_, index) => true),
            }));
        }
    }, [activePanel]);

    const handleIconClick = (icon) => {
        setActivePanel(icon === activePanel ? null : icon);
    };

    const handleGroupClick = (panel, index) => {
        setActiveGroups((prev) => ({
            ...prev,
            [panel]: prev[panel].map((item, idx) => (idx === index ? !item : item)),
        }));
    };

    // Instead of navigation, open tab and render content inside layout
    const handleItemClick = (item) => {
        setActiveTab(item.name);
        setOpenTabs((prev) => {
            if (!prev.some((tab) => tab.name === item.name)) {
                return [...prev, { ...item, key: `${item.name}-${Date.now()}` }];
            }
            return prev;
        });
        setActivePanel(false);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab.name);
    };

    const handleTabClose = (tabName) => {
        setOpenTabs((prev) => {
            const updatedTabs = prev.filter((tab) => tab.name !== tabName);
            if (activeTab === tabName) {
                const newActiveTab = updatedTabs.length > 0 ? updatedTabs[updatedTabs.length - 1] : '';
                setActiveTab(newActiveTab ? newActiveTab.name : '');
            }
            return updatedTabs;
        });
    };

    // Dummy component mapping for demonstration (replace with actual imports)
    const componentMap = {
        'Account': () => <div>Account Master Form</div>,
        'Account Group': () => <div>Account Group Form</div>,
        'Product': () => <div>Product Master Form</div>,
        'Product Group': () => <div>Product Group Form</div>,
        'Product Company': () => <div>Product Company Form</div>,
        'Unit': () => <div>Unit Master Form</div>,
        'Sales': () => <div>Sales Master Form</div>,
        'Sales Group': () => <div>Sales Group Form</div>,
        'Purchase': () => <div>Purchase Master Form</div>,
        'Purchase Group': () => <div>Purchase Group Form</div>,
        'Trial Balance': () => <div>Trial Balance Report</div>,
        'Profit & Loss A/C': () => <div>Profit & Loss Report</div>,
        'Balance Sheet': () => <div>Balance Sheet Report</div>,
        'Daybook': () => <div>Daybook Report</div>,
        'Ledger': () => <div>Ledger Report</div>,
        'Payment Register': () => <div>Payment Register</div>,
        'Receipt Register': () => <div>Receipt Register</div>,
        'Sale Register': () => <div>Sale Register</div>,
        'Purchase Register': () => <div>Purchase Register</div>,
        'Sales Return': () => <div>Sales Return</div>,
        'Purchase Return': () => <div>Purchase Return</div>,
        'Sale Accounts': () => <div>Sale Accounts</div>,
        'Purchase Accounts': () => <div>Purchase Accounts</div>,
        'Stock Summary': () => <div>Stock Summary</div>,
    };

    // Render the content of the active tab
    const renderTabContent = () => {
        const tab = openTabs.find((t) => t.name === activeTab);
        if (!tab) return null;
        const TabComponent = componentMap[tab.name] || (() => <div>Coming Soon...</div>);
        return <TabComponent />;
    };
    return (
        <>
            <div className="menu-container">
               Auditus-iERP Live Instant Demo
            </div>
            <div className="main-content-container">
                <div className={`sidebar ${isSidebarExpanded ? 'expanded' : ''}`}>
                    <FontAwesomeIcon
                        icon={faM}
                        className={`sidebar-icon ${activePanel === 'm' ? 'active' : ''}`}
                        onClick={() => handleIconClick('m')}
                    />
                    <FontAwesomeIcon
                        icon={faT}
                        className={`sidebar-icon ${activePanel === 't' ? 'active' : ''}`}
                        onClick={() => handleIconClick('t')}
                    />
                    <FontAwesomeIcon
                        icon={faR}
                        className={`sidebar-icon ${activePanel === 'r' ? 'active' : ''}`}
                        onClick={() => handleIconClick('r')}
                    />
                </div>
                <div className={`panel ${activePanel ? 'show' : ''}`}>
                    {activePanel &&
                        menuData[activePanel].map((group, index) => (
                            <div key={index} className="dropdown-group">
                                <div
                                    className="dropdown-title"
                                    onClick={() => handleGroupClick(activePanel, index)}
                                >
                                    {group.title}
                                    <FontAwesomeIcon
                                        icon={activeGroups[activePanel]?.[index] ? faChevronUp : faChevronDown}
                                        className="chevron-icon"
                                    />
                                </div>
                                {activeGroups[activePanel]?.[index] && (
                                    <ul className="dropdown-items">
                                        {group.items.map((item, idx) => (
                                            <li
                                                key={idx}
                                                className="dropdown-item"
                                                onClick={() => handleItemClick(item)}
                                            >
                                                <FontAwesomeIcon icon={itemIcons[item.name] || faFileAlt} style={{ marginRight: '8px' }} />
                                                {item.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                </div>
                <div className="content-panel">
                    <div className="tabs_Audit">
                        {openTabs.map((tab) => (
                            <div
                                key={tab.name}
                                className={`tab ${activeTab === tab.name ? 'active' : ''}`}
                            >
                                <span onClick={() => handleTabClick(tab)}>{tab.name}</span>
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    onClick={() => handleTabClose(tab.name)}
                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="tab-content">
                        {renderTabContent()}
                    </div>
                </div>
            </div>
        </>
    );
}
